/**
 * Student addresses carry the class year: `27firlas@…` is the class of 2027.
 * Staff addresses never start with a digit — firestore.rules relies on that to
 * keep the two kinds of account apart, and so does everything here.
 */

export const isStudentEmail = (email: string) => /^[0-9]/.test(email.trim())

/** `27firlas@…` → 2027. Null if the address does not start with two digits. */
export function classYearFromEmail(email: string): number | null {
  const m = /^(\d{2})/.exec(email.trim())
  return m ? 2000 + Number(m[1]) : null
}

/**
 * The class that graduates at the end of the current school year. The school
 * year turns over on July 1 — a senior in May and a senior in September are
 * different people.
 */
export function graduatingClass(now: Date = new Date()): number {
  return now.getMonth() >= 6 ? now.getFullYear() + 1 : now.getFullYear()
}

/** Grade from class year: the graduating class is in 12th. */
export function gradeFor(classYear: number, now: Date = new Date()): number {
  return 12 - (classYear - graduatingClass(now))
}
